var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { internalMessageBus, InternalMessageBusChannels } from "sb-internal-msg-bus";
import { BetslipUtilChannels } from "sb-betslip-utils-contracts";
var MessageBus = /** @class */ (function () {
    function MessageBus(topicPrefix, context) {
        this.listeners = {};
        this.globalListeners = {};
        this.bus = internalMessageBus;
        this.topicPrefix = topicPrefix;
        this.context = context;
        this.addFilterListeners();
        this.addLegacyListeners();
        this.addGlobalListeners();
        this.addBetslipListeners();
    }
    MessageBus.prototype.addFilterListeners = function () {
        var _this = this;
        Object.keys(InternalMessageBusChannels.eventsFilter).forEach(function (key) {
            _this.context[key + "Change"] && (_this.listeners[InternalMessageBusChannels.eventsFilter[key]] = key + "Change");
        });
    };
    MessageBus.prototype.addGlobalListeners = function () {
        this.globalListeners[InternalMessageBusChannels.legacy.timeZone.update] = "timeZoneChange";
        this.globalListeners[InternalMessageBusChannels.legacy.oddStyle.update] = "oddStyleChange";
        this.globalListeners[InternalMessageBusChannels.legacy.userInfo.onLogin] = "onLogin";
        this.globalListeners[InternalMessageBusChannels.legacy.userInfo.onLogout] = "onLogout";
        this.globalListeners[InternalMessageBusChannels.legacy.platformJWTChange.renewJWTToken] = "renewJWTToken";
        this.globalListeners[InternalMessageBusChannels.legacy.betslip.items.add] = "betSlipItemsAdd";
        this.globalListeners[InternalMessageBusChannels.legacy.betslip.items.remove] = "betSlipItemsRemove";
    };
    MessageBus.prototype.addBetslipListeners = function () {
        this.globalListeners[BetslipUtilChannels.Broadcast.Status] = "betSlipStatusReceived";
        this.globalListeners[BetslipUtilChannels.Broadcast.Items.added] = "betslipAddedItemsReceived";
        this.globalListeners[BetslipUtilChannels.Broadcast.Items.removed] = "betslipRemovedItemsReceived";
        this.globalListeners[BetslipUtilChannels.Broadcast.Items.cleared] = "betslipClearedItemsReceived";
    };
    MessageBus.prototype.addLegacyListeners = function () {
        this.listeners[InternalMessageBusChannels.legacy.eventCard.changedToSide] = "changedToSide";
        this.listeners[InternalMessageBusChannels.legacy.filter.events.none] = "allEventsChange";
        this.listeners[InternalMessageBusChannels.legacy.filter.events.liveStream] = "liveStreamingChange";
        this.listeners[InternalMessageBusChannels.legacy.filter.events.fastMaskets] = "fastMarketsChange";
        this.listeners[InternalMessageBusChannels.legacy.activeEvent.update] = "activeEventIdChange";
    };
    MessageBus.prototype.msgRouter = function (msg) {
        var _a;
        var handler = this.listeners[(msg.channel + "." + msg.subChannel.join(".")).replace(this.topicPrefix, "")];
        this.context[handler] && (_a = this.context)[handler].apply(_a, __spread(msg.data));
    };
    MessageBus.prototype.msgRouterGlobal = function (msg) {
        var _a;
        var handler = this.globalListeners[msg.channel + "." + msg.subChannel.join(".")];
        this.context[handler] && (_a = this.context)[handler].apply(_a, __spread(msg.data));
    };
    MessageBus.prototype.attachListeners = function () {
        var _this = this;
        Object.keys(this.listeners).forEach(function (x) { return _this.bus.on("" + _this.topicPrefix + x, _this.msgRouter, _this); });
        Object.keys(this.globalListeners).forEach(function (x) { return _this.bus.on(x, _this.msgRouterGlobal, _this); });
    };
    MessageBus.prototype.dettachListeners = function () {
        var _this = this;
        Object.keys(this.listeners).forEach(function (x) { return _this.bus.off("" + _this.topicPrefix + x, _this.msgRouter, _this); });
        Object.keys(this.globalListeners).forEach(function (x) { return _this.bus.off(x, _this.msgRouterGlobal, _this); });
    };
    MessageBus.prototype.requestGlobalListeners = function (timeZoneChangeHandler, oddStyleChangeHandler, onLoginHandler) {
        internalMessageBus.emit(InternalMessageBusChannels.legacy.timeZone.request, { callback: timeZoneChangeHandler });
        internalMessageBus.emit(InternalMessageBusChannels.legacy.oddStyle.request, { callback: oddStyleChangeHandler });
        internalMessageBus.emit(InternalMessageBusChannels.legacy.userInfo.request, { callback: onLoginHandler });
    };
    MessageBus.prototype.sendBsUtilStatusMessage = function () {
        this.bus.emit(BetslipUtilChannels.Listen.Commands.get_status);
    };
    MessageBus.prototype.sendBsUtilItemsAddMessage = function (data) {
        this.bus.emit(BetslipUtilChannels.Listen.Commands.add_items, data);
    };
    MessageBus.prototype.sendBsUtilItemsRemoveMessage = function (data) {
        this.bus.emit(BetslipUtilChannels.Listen.Commands.remove_items, data);
    };
    MessageBus.prototype.sendEventCountMessage = function (eventsCount, sportId) {
        this.bus.emit("" + this.topicPrefix + InternalMessageBusChannels.eventsList.count, { eventsCount: eventsCount, sportId: sportId });
    };
    MessageBus.prototype.sendActiveEventMessage = function (eventId, isOutright) {
        this.bus.emit("" + this.topicPrefix + InternalMessageBusChannels.legacy.activeEvent.init, { eventId: eventId, isOutright: isOutright });
    };
    MessageBus.prototype.sendTagsMessage = function (message) {
        this.bus.emit("" + this.topicPrefix + InternalMessageBusChannels.eventsList.tags, message);
    };
    MessageBus.prototype.sendLiveStreamMessage = function (eventId) {
        this.bus.emit(InternalMessageBusChannels.legacy.liveStream.update, parseInt(eventId));
    };
    return MessageBus;
}());
export { MessageBus };
//# sourceMappingURL=MessageBus.js.map